import {
  Container,
  Grid,
  Box,
  makeStyles,
  useTheme,
  useMediaQuery,
  Slide,
  Fade,
  Grow,
  Typography,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9)), url("/static/about.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  section: {
    padding: "40px 0",
    [theme.breakpoints.down('sm')]: {
      padding: "28px 0",
    },
  },
  sectionAlt: {
    padding: "40px 0",
    background: "#fafafa",
    [theme.breakpoints.down('sm')]: {
      padding: "28px 0",
    },
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  contentCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
    },
  },
  contentText: {
    fontSize: "0.85rem",
    color: "#444444",
    lineHeight: 1.7,
    "& p": {
      marginBottom: 12,
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      color: "#4c004c",
      marginTop: 16,
      marginBottom: 8,
      fontSize: "1rem",
    },
    "& ul, & ol": {
      paddingLeft: 20,
      marginBottom: 12,
    },
    "& li": {
      marginBottom: 6,
    },
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    textAlign: "center",
  },
  quoteIcon: {
    fontSize: 28,
    color: "rgba(255, 255, 255, 0.15)",
    display: "block",
    margin: "0 auto 10px",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    textAlign: "center",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
  valueCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "20px",
    height: "100%",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease",
    textAlign: "center",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(107, 27, 107, 0.1)",
    },
  },
  valueTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: 8,
  },
  valueText: {
    fontSize: "0.78rem",
    color: "#666666",
    lineHeight: 1.5,
  },
}));

export const AboutUs = () => {
  const theme = useTheme();

  const classes = useStyles();
  const [data, setData] = useState();
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 6);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
    Axios.post("/api/select_aboutus", {
      headers: { headKey: headKey },
    }).then((res) => {
      console.log("hit");
      console.log(res.data.status);
      if (res.data.status) {
        console.log(res.data.status);
        setData(ReactHtmlParser(res.data.data.description));
      }
    });
  };

  const values = [
    { title: "Innovation", text: "Pushing boundaries with cutting-edge solutions" },
    { title: "Excellence", text: "Delivering quality that exceeds expectations" },
    { title: "Integrity", text: "Building trust through transparent partnerships" },
    { title: "Collaboration", text: "Working together to achieve shared success" },
  ];

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>

      {isloading ? (
        <Loading />
      ) : (
        <>
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <Fade in={true} timeout={1000}>
              <Box className={classes.heroContent}>
                <Typography className={classes.heroLabel}>
                </Typography>
                <Typography className={classes.heroTitle}>
                  About Us
                </Typography>
                <Box className={classes.heroDivider} />
                <Typography className={classes.heroSubtitle}>
                  Crafting Excellence Through Unique IT Services — Transforming Ideas Into Powerful Digital Solutions Since 2018
                </Typography>
              </Box>
            </Fade>
          </Box>

          {/* Story Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Story & Vision
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Learn about our journey, values, and the drive behind our innovations
                  </Typography>
                </Box>
              </Slide>

              <Fade in={true} timeout={1000}>
                <Box className={classes.contentCard}>
                  <Box className={classes.contentText}>
                    {data}
                  </Box>
                </Box>
              </Fade>
            </Container>
          </Box>

          {/* Values Section */}
          <Box className={classes.sectionAlt}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Core Values
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    The principles that guide everything we do
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={3}>
                {values.map((value, index) => (
                  <Grid item xs={6} sm={6} md={3} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.valueCard}>
                        <Typography className={classes.valueTitle}>
                          {value.title}
                        </Typography>
                        <Typography className={classes.valueText}>
                          {value.text}
                        </Typography>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* CEO Quote Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={1000}>
                <Box className={classes.quoteSection}>
                  <FormatQuoteIcon className={classes.quoteIcon} />
                  <Typography className={classes.quoteText}>
                    "At Arawinz, our ethos is rooted in the seamless fusion of creativity and commitment, 
                    driving us to provide outstanding results. Our path is defined by an unwavering dedication 
                    to surpassing expectations and an earnest endeavor to grasp and cater to our clients' 
                    unique requirements. As a collective, we transcend mere collaboration – we are visionaries 
                    shaping tomorrow, piecing together a more intelligent and interconnected reality."
                  </Typography>
                  <Typography className={classes.quoteAuthor}>
                    — Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Slide>
            </Container>
          </Box>
        </>
      )}
    </div>
  );
};
